<template>
    <div>
        <v-container>
            <v-row>
                <v-col md="12" class="text-right">
                    <router-link :to="{name: 'YourRegistration'}">{{ $t("viewRegistration.back") }}</router-link>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="3">
                    <v-card class="mx-auto">
                        <v-card-title :style="`background:${headerColor}`" class="cardTitle">
                            <img :src="urlImage" alt="LiveLaps" height="50" border="0" />
                        </v-card-title>
                        <v-card-text class="bcard">
                            <v-row>
                                <v-col md="12" class="text-left">
                                    <v-row >
                                        <v-col md="4">
                                            <p>{{ $t("viewRegistration.event") }}: </p>
                                            <p>{{ $t("viewRegistration.promoter") }}: </p>
                                            <p>{{ $t("viewRegistration.name") }}: </p>
                                            <p>{{ $t("viewRegistration.class") }}: </p>
                                            <p>{{ $t("viewRegistration.number") }}: </p>
                                            <p>{{ $t("viewRegistration.token") }}: </p>
                                        </v-col>
                                        <v-col md="8">
                                            <p>{{ registrant.eventName }}</p>
                                            <p>{{ registrant.promoterName }}</p>
                                            <p>{{ registrant.regName }}</p>
                                            <p>{{ registrant.className }}</p>
                                            <p>{{ registrant.number }}</p>
                                            <p>{{ registrant.token }}</p>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import RegistrationService from '../../services/RegistrationService';
import { mapGetters } from 'vuex';

export default {
    name: "ViewRegistration",
    data() {
        return {
            id: 0,
            registrant: {
                eventName: ''
            },
            headerColor: '#000'
        }
    },
    computed: {
        ...mapGetters({
            url_image: 'vueAppLogoView'
        })
    },
    created(){
        this.headerColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    },
    mounted() {
        this.$emit("titlePage", "viewRegistration.title");
        this.$emit("dynamicMenuItems", this.dynamicMenuItems);
        this.id = this.$route.params.id;
        this.getRegistration();
    },
    methods: {
        getRegistration(){
            RegistrationService.getRegistrationById(this.id).then(response =>{
                if(response.data.success == 1){
                    this.registrant = response.data.message;
                }
            });
        }
    },
}
</script>
<style scoped>
    .bcard p{
        margin-bottom: 0;
    }
</style>